<template>
<el-date-picker
    v-model="selectTime"
    type="datetimerange"
    @change="handleChange"

    align="center"
    :range-separator="rangeSeparator"
    :start-placeholder="startPlaceholder || $t(/*开始时间*/'c.begin_time')"
    :end-placeholder="endPlaceholder || $t(/*结束时间*/'c.end_time')"
    :clearable="clearable"
    :disabled="disabled"
    :default-time="['00:00:00', '00:00:00']"
/>
</template>

<script>
import Core from '../../core';
import dayjs from 'dayjs';

export default {
    model: {
        prop: 'value',
        event: 'update'
    },
    props: {
        value: { type: Object, default: () => ({}) },
        keys: { type: Array, default: () => (['begin_time', 'end_time']) },

        rangeSeparator: { type: String, default: '~' },
        startPlaceholder: { type: String },
        endPlaceholder: { type: String },
        clearable: { type: Boolean, default: false },
        disabled: { type: Boolean, default: false },
    },
    data() {
        return {
            selectTime: [],
        };
    },
    watch: {
        value: {
            immediate: true,
            handler(n) {
                console.log('watch value:', n)
            }
        }
    },
    methods: {
        handleChange() {
            console.log('handleChange:', this.selectTime)
            let obj = {}
            if (!this.selectTime || this.selectTime.length < this.keys.length) {
                for (let i = 0; i < this.keys.length; i++) {
                    obj[this.keys[i]] = ''
                }
            } else {
                for (let i = 0; i < this.keys.length; i++) {
                    obj[this.keys[i]] = this.$U.countFilter(this.selectTime[i].getTime(), 1000, 0) || ''
                }
            }
            console.log('handleChange:', obj)
            this.$emit('update', obj);
            this.$emit('change', obj);
        }
    },
};
</script>
